import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { UserRegistration } from '@app/registration-request/model/user-registration';

@Injectable({
  providedIn: 'root',
})
export class EmailService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public sendEmail(email: Email, isPublic = true) {
    const formData = new FormData();
    formData.append('Subject', email.subject);
    formData.append('TemplateId', email.templateId.toString());
    formData.append('Recipient', encodeURIComponent(email.recipient));
    if (email.cc) {
      formData.append('Cc', encodeURIComponent(email.cc));
    }
    if (email.data) {
      formData.append('Data', email.data);
    }
    if (email.attachments) {
      email.attachments.forEach((a) => {
        formData.append('Attachments', a.file, a.name);
      });
    }
    if (email.isHighImportance) {
      formData.append('isHighImportance', email.isHighImportance.toString());
    }

    if (isPublic) {
      return this.http.post(this.directEndpoint('api', 'emailservice', 'email'), formData);
    }

    return this.http.post(this.endpoint('api', 'emailservice', 'email'), formData);
  }
}

export interface Email {
  subject: string;
  templateId: number;
  recipient: string;
  cc?: string;
  data?: string;
  isHighImportance?: boolean;
  attachments?: EmailAttachment[];
}

export interface EmailData extends Email {
  registrationData: UserRegistration;
}

export interface EmailAttachment {
  file: Blob;
  name: string;
}
